<template>
  <v-table
    :count="count"
    :list="list"
    :is-loading="isLoading"
    :push-list="refresh"
    :query-list="queryList"
    :is-show-store-select="true"
    :is-multiple-store="true"
    :is-store-select-clearable="true"
    :is-show-teacher-select="true"
    :is-show-month-range-picker="true"
    :picker-options="pickerOptions"
    :show-summary="true"
  >
    <el-table-column label="日期">
      <template v-slot="{ row }">
        {{ row.report_date | timeToYm }}
      </template>
    </el-table-column>
    <el-table-column label="门店" prop="store_name"/>
    <el-table-column label="老师" align="center" width="130">
      <template v-slot="{ row }">
        <v-avatar-nickname :value="row.avatar" :nickname="row.nickname"/>
      </template>
    </el-table-column>
    <el-table-column label="大课" width="190" align="center" prop="group_course_pay">
      <template v-slot="{ row }">
        <div class="flex-center">
          <template v-if="row.group_course_count && row.group_course_pay">
            {{ row.group_course_count }}
            <span class="separator">×</span>
            {{ row.class_pay | toYuan }}
            <span class="separator">=</span>
            <b>{{ row.group_course_pay | toYuan }}</b>
          </template>
          <template v-else>-</template>
        </div>
      </template>
    </el-table-column>

    <el-table-column label="成人班" width="190" align="center" prop="adult_course_pay" type="money">
      <template v-slot="{ row }">
        <div class="flex-center">
          <template v-if="row.adult_course_count">
            {{ row.adult_course_count }}
            <span class="separator">×</span>
            {{ row.adult_class_pay | toYuan }}
            <span class="separator">=</span>
            <b>{{ row.adult_course_pay | toYuan }}</b>
          </template>
          <template v-else>-</template>
        </div>
      </template>
    </el-table-column>

    <el-table-column label="少儿班" width="190" align="center" prop="child_course_pay" type="money">
      <template v-slot="{ row }">
        <div class="flex-center">
          <template v-if="row.child_course_count">
            {{ row.child_course_count }}
            <span class="separator">×</span>
            {{ row.child_class_pay | toYuan }}
            <span class="separator">=</span>
            <b>{{ row.child_course_pay | toYuan }}</b>
          </template>
          <template v-else>-</template>
        </div>
      </template>
    </el-table-column>

    <el-table-column label="专业班" width="190" align="center" prop="major_course_pay" type="money">
      <template v-slot="{ row }">
        <div class="flex-center">
          <template v-if="row.major_course_count">
            {{ row.major_course_count }}
            <span class="separator">×</span>
            {{ row.major_class_pay | toYuan }}
            <span class="separator">=</span>
            <b>{{ row.major_course_pay | toYuan }}</b>
          </template>
          <template v-else>-</template>
        </div>
      </template>
    </el-table-column>

    <el-table-column label="私教" align="center" width="190" prop="private_course_pay">
      <template v-slot="{ row }">
        <div class="flex-center">
          <template v-if="row.private_course_count">
            {{ row.private_course_count }}
            <span class="separator">×</span>
            {{ row.private_class_pay | toYuan }}
            <span class="separator">=</span>
            <b>{{ row.private_course_pay  | toYuan }}</b>
          </template>
          <template v-else>-</template>
        </div>
      </template>
    </el-table-column>
    <el-table-column label="旷课" align="center" width="190" prop="absence_pay">
      <template v-slot="{ row }">
        <div class="flex-center">
          <template v-if="row.absence_count">
            {{ row.absence_count }}
            <span class="separator">×</span>
            {{ row.leave_class_pay | toYuan }}
            <span class="separator">=</span>
            <b>{{ row.absence_pay | toYuan }}</b>
          </template>
          <template v-else>-</template>
        </div>
      </template>
    </el-table-column>
    <el-table-column label="底薪" align="center" width="76" prop="base_pay" type="money">
      <template v-slot="{ row }">
        <template v-if="row.base_pay">{{ row.base_pay | toYuan }}</template>
        <template v-else>-</template>
      </template>
    </el-table-column>
    <el-table-column label="公司社保" align="center" prop="social_insurance" type="money">
      <template v-slot="{ row }">
        <template v-if="row.social_insurance">{{ row.social_insurance | toYuan }}</template>
        <template v-else>-</template>
      </template>
    </el-table-column>
    <el-table-column label="个人社保" align="center" width="76" prop="personal_insurance" type="money">
      <template v-slot="{ row }">
        <template v-if="row.personal_insurance">{{ row.personal_insurance | toYuan }}</template>
        <template v-else>-</template>
      </template>
    </el-table-column>
    <el-table-column label="绩效" width="76" align="center" prop="bonus" type="money">
      <template v-slot="{ row }">
        <template v-if="row.bonus">{{ row.bonus | toYuan }}</template>
        <template v-else>-</template>
      </template>
    </el-table-column>
    <el-table-column label="实发" align="center" prop="actual_pay" type="money">
      <template v-slot="{ row }">
        {{ row.actual_pay | toYuan }}
      </template>
    </el-table-column>
    <el-table-column label="合计" align="center" prop="all_pay" type="money">
      <template v-slot="{ row }">
        <span class="success-color">{{ row.all_pay | toYuan }}</span>
      </template>
    </el-table-column>
<!--    <el-table-column label="操作" align="center">
      <template v-slot="{ $index, row }">
        <el-button class="table-button" size="mini" type="primary" @click="getTeacherCourses(row)">详情</el-button>
        <el-button class="table-button" size="mini" type="success" @click="showPayslip(row)">工资条</el-button>
      </template>
    </el-table-column>-->
    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`teacher-salary-record-list-${k}-${v.id || k}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>日期</span>
              <span>{{ v.report_date | timeToYm }}</span>
            </div>
            <div class="list-item-detail">
              <span>门店</span>
              <span>{{ v.store_name }}</span>
            </div>
            <div class="list-item-detail">
              <span>老师</span>
              <v-avatar-nickname
                :value="v.avatar"
                :nickname="v.nickname"
                :avatar-size="50"
                width="30vw"
              />
            </div>
            <div class="list-item-detail">
              <span>大课</span>
              <span v-if="v.group_course_count && v.group_course_pay">{{ v.group_course_count }} × {{ v.class_pay | toYuan }} = {{ v.group_course_pay | toYuan }}</span>
              <span v-else>-</span>
            </div>
            <div class="list-item-detail">
              <span>成人班</span>
              <span v-if="v.adult_course_count">{{ v.adult_course_count }} × {{ v.adult_class_pay | toYuan }} = {{ v.adult_course_pay | toYuan }}</span>
              <span v-else>-</span>
            </div>
            <div class="list-item-detail">
              <span>少儿班</span>
              <span v-if="v.child_course_count">{{ v.child_course_count }} × {{ v.child_class_pay | toYuan }} = {{ v.child_course_pay | toYuan }}</span>
              <span v-else>-</span>
            </div>
            <div class="list-item-detail">
              <span>专业班</span>
              <span v-if="v.major_course_count">{{ v.major_course_count }} × {{ v.major_class_pay | toYuan }} = {{ v.major_course_pay | toYuan }}</span>
              <span v-else>-</span>
            </div>
            <div class="list-item-detail">
              <span>私教</span>
              <span v-if="v.private_course_count">{{ v.private_course_count }} × {{ v.private_class_pay | toYuan }} = {{ v.private_course_pay | toYuan }}</span>
              <span v-else>-</span>
            </div>
            <div class="list-item-detail">
              <span>旷课</span>
              <span v-if="v.absence_count">{{ v.absence_count }} × {{ v.leave_class_pay | toYuan }} = {{ v.absence_pay | toYuan }}</span>
              <span v-else>-</span>
            </div>
            <div class="list-item-detail">
              <span>底薪</span>
              <span v-if="v.base_pay">{{ v.base_pay | toYuan }}</span>
              <span v-else>-</span>
            </div>
            <div class="list-item-detail">
              <span>公司社保</span>
              <span v-if="v.social_insurance">{{ v.social_insurance | toYuan }}</span>
              <span v-else>-</span>
            </div>
            <div class="list-item-detail">
              <span>个人社保</span>
              <span v-if="v.personal_insurance">{{ v.personal_insurance | toYuan }}</span>
              <span v-else>-</span>
            </div>
            <div class="list-item-detail">
              <span>绩效</span>
              <span v-if="v.bonus">{{ v.bonus | toYuan }}</span>
              <span v-else>-</span>
            </div>
            <div class="list-item-detail">
              <span>实发</span>
              <span>{{ v.actual_pay | toYuan }}</span>
            </div>
            <div class="list-item-detail">
              <span>合计</span>
              <span class="success-color">{{ v.all_pay | toYuan }}</span>
            </div>
          </div>

          <div class="list-item list-count-box primary-background-light">
            <div class="list-item-detail">
              <strong>本页合计</strong>
            </div>
            <div class="list-item-detail">
              <span>成人班</span>
              <span class="income-count">{{ adultCoursePay | toYuan }} 元</span>
            </div>
            <div class="list-item-detail">
              <span>少儿班</span>
              <span class="income-count">{{ childCoursePay | toYuan }} 元</span>
            </div>
            <div class="list-item-detail">
              <span>专业班</span>
              <span class="income-count">{{ majorCoursePay | toYuan }} 元</span>
            </div>
            <div class="list-item-detail">
              <span>底薪</span>
              <span class="income-count">{{ basePay | toYuan }} 元</span>
            </div>
            <div class="list-item-detail">
              <span>公司社保</span>
              <span class="pay-count">{{ socialInsurance | toYuan }} 元</span>
            </div>
            <div class="list-item-detail">
              <span>个人社保</span>
              <span class="pay-count">{{ personalInsurance | toYuan }} 元</span>
            </div>
            <div class="list-item-detail">
              <span>绩效</span>
              <span class="income-count">{{ bonus | toYuan }} 元</span>
            </div>
            <div class="list-item-detail">
              <span>实发</span>
              <span class="income-count">{{ actualPay | toYuan }} 元</span>
            </div>
            <div class="list-item-detail">
              <span>合计</span>
              <span class="income-count">{{ allPay | toYuan }} 元</span>
            </div>
          </div>
        </template>
        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>
  </v-table>
</template>

<script>
import RouteConfig from '@/router/config';
import { mapGetters } from 'vuex';
import { getSalaryList } from '@/api/teacher';
import {
  getLegalQueryList,
  pickerOptionsBetweenSystemStartAndToday
} from '@/utils/formats';
import { checkYmdIsBetweenSetUpAndToday } from '@/utils/validate';
import { plus, toYuan } from '@/filters';

export default {
  name: RouteConfig.teacherSalaryRecordList.name,
  data: () => ({
    RouteConfig,
    isLoading: false,
    isDeleting: {},
    isGetting: {},
    count: 0,
    average_attendance: 0,
    adultCoursePay: 0,
    childCoursePay: 0,
    majorCoursePay: 0,
    basePay: 0,
    socialInsurance: 0,
    personalInsurance: 0,
    bonus: 0,
    actualPay: 0,
    allPay: 0,
    qrCode: {
      src: '',
    },
    list: [],
    timeLimit: [],
    queryList: {
      teacher_ids: [],
      store_ids: [],
      start_date: '',
      end_date: '',
      is_asc: 0,
      page: 1,
      size: 10,
    },
    pickerOptionsBetweenSystemStartAndToday,
    pickerOptions: {
      disabledDate: time => time.getTime() >= Date.now(),
      shortcuts: [
        {
          text: '上月',
          onClick(picker) {
            let currentDate = new Date();
            let lastMonth = currentDate.getMonth() - 1;
            let currentYear = currentDate.getFullYear();
            let startDate = new Date(currentYear, lastMonth,1);
            let endDate = new Date(currentYear, lastMonth, 31);
            picker.$emit('pick', [startDate, endDate]);
          },
        },
        {
          text: '去年',
          onClick(picker) {
            let currentDate = new Date();
            let currentYear = currentDate.getFullYear() - 1;
            let startDate = new Date(currentYear, 0,1);
            let endDate = new Date(currentYear, 11,31);
            picker.$emit('pick', [startDate, endDate]);
          },
        },
        {
          text: '今年',
          onClick(picker) {
            let currentDate = new Date();
            let currentMonth = currentDate.getMonth();
            let currentYear = currentDate.getFullYear();
            let startDate = new Date(currentYear, 0,1);
            let endDate = new Date(currentYear, currentMonth,1);
            picker.$emit('pick', [startDate, endDate]);
          },
        },
      ],
    },
  }),
  computed: {
    ...mapGetters([
      'isAdministrator',
      'isHeadOffice',
      'isManager',
      'isReceptionist',
      'isMobile',
      'isPc',
      'userStoreId',
    ]),
  },
  watch: {
    '$route'(to) {
      this.load(to);
    },
    queryList(queryList) {
      if (!this.isMobile) return;
      this.timeLimit = [queryList.start_date, queryList.end_date];
    },
  },
  beforeMount() {
    const lastMonth = this.getLastMonth();
    this.queryList.start_date = lastMonth;
    this.queryList.end_date = lastMonth;
    this.timeLimit = [this.queryList.start_date, this.queryList.end_date];
    this.load();
  },
  methods: {
    getLastMonth() {
      const date = new Date();
      // 将日期设置为上个月
      date.setMonth(date.getMonth() - 1);

      // 获取上个月的年份和月份
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 确保是两位数

      return `${year}-${month}`;
    },
    refresh(query = this.queryList) {
      RouteConfig.teacherSalaryRecordList.push(query);
    },
    handlePageChange({ page, size }) {
      this.queryList.page = page;
      this.queryList.size = size;
      this.refresh();
    },
    handleStoreChange() {
      this.queryList.page = 1;
      this.refresh();
    },
    handleTimeLimitChange(times) {
      if (!times || !times.length) times = ['', ''];

      this.timeLimit = times;
      const [start_date, end_date] = times;

      Object.assign(this.queryList, {
        start_date,
        end_date,
        page: 1,
      });
      this.refresh();
    },
    async load(route = this.$route, next) {
      const { queryList } = this;
      const { query } = route;
      getLegalQueryList(queryList, query);

      const startDateIsValid = checkYmdIsBetweenSetUpAndToday(query.start_date);
      const endDateIsValid = checkYmdIsBetweenSetUpAndToday(query.end_date);

      if (startDateIsValid && endDateIsValid) {
        queryList.start_date = query.start_date;
        queryList.end_date = query.end_date;
      }

      this.isLoading = true;
      const { isError, data } = await getSalaryList(queryList);
      this.isLoading = false;

      if (next) next();
      if (isError) return;

      this.count = data.count;
      // 课时数字段存储为小时×100，前端回显需转为小时
      data.list.forEach(v => {
        v.group_course_count = toYuan(v.group_course_count);
        v.private_course_count = toYuan(v.private_course_count);
        v.adult_course_count = toYuan(v.adult_course_count);
        v.child_course_count = toYuan(v.child_course_count);
        v.major_course_count = toYuan(v.major_course_count);
        v.absence_count = toYuan(v.absence_count);
      });
      this.list = data.list;

      const list = data.list;
      const length = list.length;

      let adultCoursePay = 0;
      let childCoursePay = 0;
      let majorCoursePay = 0;
      let basePay = 0;
      let socialInsurance = 0;
      let personalInsurance = 0;
      let bonus = 0;
      let actualPay = 0;
      let allPay = 0;

      for (let i = 0; i < length; i++) {
        adultCoursePay = plus(adultCoursePay, list[i].adult_course_pay);
        childCoursePay = plus(childCoursePay, list[i].child_course_pay);
        majorCoursePay = plus(majorCoursePay, list[i].major_course_pay);
        basePay = plus(basePay, list[i].base_pay);
        socialInsurance = plus(socialInsurance, list[i].social_insurance);
        personalInsurance = plus(personalInsurance, list[i].personal_insurance);
        bonus = plus(bonus, list[i].bonus);
        actualPay = plus(actualPay, list[i].actual_pay);
        allPay = plus(allPay, list[i].all_pay);
      }

      Object.assign(this, {
        adultCoursePay,
        childCoursePay,
        majorCoursePay,
        basePay,
        socialInsurance,
        personalInsurance,
        bonus,
        actualPay,
        allPay,
      });
    },

  },
};
</script>
